
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'
import MEDIA from 'constants/media'


import SelectArrow from 'assets/images/select-arrow.svg'

import { Props } from './types'

export const SelectFieldWrap = styled.div`
  position: relative;
`

export const SelectField = styled.select<Props>`
  appearance: none;
  border: ${(props: Props): string =>
    (!props.valid && (props.touched || props.alwaysShowError) && `1px solid ${COLORS.ERROR}`) ||
    (!props.valid && props.value && `1px solid ${COLORS.WARNING}`) ||
    '1px solid #999'};
  border-radius: 4px;
  background-image: url(${SelectArrow});
  background-color: ${COLORS.WHITE};
  background-size: 30px 20px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  box-shadow: inset 0px 1px 8px rgba(0, 0, 0, 0.2);
  display: block;
  cursor: pointer;
  height: 48px;
  width: 100%;
  padding: 8px 45px 8px 8px;
  font-size: ${FONTS.FONTINPUTSMOBILE};
  &:hover {
    box-shadow: none;
  }
  &:focus {
    outline: none;
    background-color: ${COLORS.WHITE};
    border-bottom: 1px solid ${COLORS.BORDERS};
  }
  &:invalid {
    color: ${COLORS.GREYMEDIUM};
  }
  ${MEDIA.medium`
    font-size: ${FONTS.FONTINPUTS};
  `}
  ${MEDIA.ie11`
    background-image: none;
    padding-right: 8px;
  `}
`
